// extracted by mini-css-extract-plugin
export default {"container":"Access_container__+VMmd","header":"Access_header__cucib","title":"Access_title__C7sUR","tabsWrapper":"Access_tabsWrapper__GXOJ4"};